<template>
  <div v-loading="qLoading" style="line-height:1.8">
    <div>
      <!--      单选题-->
      <div v-if="qType===0">
        <div class="q-title" v-html="question.theme"/>
        <div class="q-content">
          <el-radio-group v-model="question.blank">
            <el-radio v-for="item in question.optionItem" :key="item.prefix" :label="item.prefix">
              <span class="question-prefix">{{ item.prefix }}. </span>
              <span v-html="item.content" class="q-item-span-content"></span>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <!--      多选题-->
      <div v-else-if="qType===1">
        <div class="q-title" v-html="question.theme"/>
        <div class="q-content">
          <el-checkbox-group v-model="question.blank">
            <el-checkbox v-for="item in question.optionItem" :label="item.prefix" :key="item.prefix">
              <span class="question-prefix">{{ item.prefix }}. </span>
              <span v-html="item.content" class="q-item-span-content"></span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <!--      判断题-->
      <div v-else-if="qType===2">
        <div class="q-title" v-html="question.theme" style="display: inline;margin-right: 10px"/>
        <span style="padding-right: 10px;">(</span>
        <el-radio-group v-model="question.blank">
          <el-radio v-for="item in question.optionItem" :key="item.prefix" :label="item.prefix">
            {{ item.prefix }}. <span v-html="item.content" class="q-item-span-content"></span>
          </el-radio>
        </el-radio-group>
        <span style="padding-left: 10px;">)</span>
      </div>
      <!--      简答题-->
      <div v-else-if="qType===3">
        <div class="q-title" v-html="question.theme"/>
        <div>
          <el-input v-model="question.blank" type="textarea" rows="5" @focus="inputClick(question,'blank')"></el-input>
        </div>
      </div>
      <div class="question-answer-show-item" style="margin-top: 20px;">
        题目分数: <span style="color: red;">{{ question.title_score }}</span>
      </div>
      <br/>
    </div>
    <el-dialog :visible.sync="richEditor.dialogVisible" append-to-body :close-on-click-modal="false"
               width="92%" top="3vh" custom-class="short-answer-editor-dialog"
               :show-close="false" center>
      <div class="short-answer-editor-content">
        <div class="editor-question-preview" role="region" aria-label="当前简答题题目">
          <div class="editor-question-preview-heading">
            <span class="editor-question-preview-label">当前题目（简答题）</span>
            <span class="editor-question-preview-tip">请对照题目在下方作答</span>
          </div>
          <div class="q-title editor-question-preview-theme" v-html="question.theme"></div>
        </div>
        <Ueditor @ready="editorReady"/>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editorConfirm">确 定</el-button>
        <el-button @click="richEditor.dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="clearRichEditor">清空</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Ueditor from '@/components/Ueditor'


export default {
  name: 'ShowTitleAnswer',
  components: {Ueditor},
  data() {
    return {
      richEditor: {
        dialogVisible: false,
        object: null,
        parameterName: '',
        instance: null
      },
    }
  },
  props: {
    question: {
      type: Object,
      default: function () {
        return {}
      }
    },
    qLoading: {
      type: Boolean,
      default: false
    },
    qType: {
      type: Number,
      default: 0
    }
  },
  methods: {
    editorReady(instance) {
      this.richEditor.instance = instance
      let currentContent = this.richEditor.object[this.richEditor.parameterName]
      this.richEditor.instance.setContent(currentContent)
      this.richEditor.instance.focus(true)
    },
    inputClick(object, parameterName) {
      this.richEditor.object = object
      this.richEditor.parameterName = parameterName
      this.richEditor.dialogVisible = true
    },
    editorConfirm() {
      let content = this.richEditor.instance.getContent()
      this.richEditor.object[this.richEditor.parameterName] = content
      this.richEditor.dialogVisible = false
    },
    clearRichEditor() {
      this.richEditor.instance.setContent('');
    },

  },
  computed: {}
}
</script>
<style scoped>
.editor-question-preview {
  position: sticky;
  top: 0;
  z-index: 20;
  max-height: 30vh;
  margin-bottom: 16px;
  padding: 12px 16px;
  overflow-y: auto;
  border: 1px solid #91caff;
  border-left: 5px solid #409eff;
  border-radius: 8px;
  background: #f0f7ff;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.12);
}

.short-answer-editor-content {
  max-height: calc(100vh - 180px);
  overflow-y: auto;
  padding: 0 2px;
}

.editor-question-preview-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.editor-question-preview-label {
  color: #1f5f99;
  font-size: 15px;
  font-weight: 700;
}

.editor-question-preview-tip {
  color: #6b7785;
  font-size: 12px;
}

.editor-question-preview-theme {
  margin-top: 8px;
  color: #1f2937;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.7;
}

@media (max-width: 768px) {
  .editor-question-preview-heading {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
}
</style>
